import Dashboard from './views/Dashboard/Dashboard.vue';
import Login from './views/Login/Login.vue';
import Demonstrativo from './views/Demonstrativo/Demonstrativo.vue';
import RegistroPontoUnidade from './views/RegistroPontoUnidade/RegistroPontoUnidade.vue';
import LancamentoFolha from './views/LancamentoFolha/LancamentoFolha.vue';
import AprovacaoOcorrencia from './views/AprovacaoOcorrencia/AprovacaoOcorrencia.vue';
import ProgramacaoFerias from './views/ProgramacaoFerias/ProgramacaoFerias.vue';
import Solicitacao from './views/Solicitacao/Solicitacao.vue';
import Documentos from './views/Documentos/Documentos.vue';
import Admissao from './views/Admissao/Admissao.vue';
import Relatorio from './views/Relatorio/Relatorio.vue';
import QuadroGeralVinculo from './views/QuadroGeralVinculo/QuadroGeralVinculo.vue';
import ControleEntregaEPI from './views/ControleEntregaEPI/ControleEntregaEPI.vue';
import HierarquiaOrganizacao from './views/HierarquiaOrganizacao/HierarquiaOrganizacao.vue';
import RecrutamentoSelecao from './views/RecrutamentoSelecao/RecrutamentoSelecao.vue';
import BiometriaFacial from './views/BiometriaFacial/BiometriaFacial.vue';
import IndicadoresSST from './views/Indicadores/IndicadoresAcidentes.vue';
import IndicadoresEpis from './views/Indicadores/IndicadoresEpis.vue';
import IndicadoresReunioes from './views/Indicadores/IndicadoresReunioes.vue';
import IndicadoresAfastamentos from './views/Indicadores/IndicadoresAfastamentos.vue';
import OcorrenciasPontoOffline from './views/OcorrenciasPontoOffline/OcorrenciasPontoOffline.vue';
import OfflineController from '@/assets/ts/controller/OfflineController';
import ComunicadoAcidenteTrabalho from '@/views/ComunicadoAcidenteTrabalho/ComunicadoAcidenteTrabalho.vue'
import ControleAcesso from './views/ControleAcesso/ControleAcesso.vue';
import { ActionPermissao, ModuloPermissao } from './assets/ts/controller/ControleAcessoController';
import IndicadoresVariacaoSalarial from './views/Indicadores/IndicadoresVariacaoSalarial.vue';
import MesaOperacoes from '@/views/MesaOperacoes/MesaOperacoes.vue';
import RegistroPontoNovo from './views/RegistroPontoNovo/RegistroPontoNovo.vue';
import { VueClass } from './interfaces/vue';
import AnalisePreditivaTurnover from './views/AnalisePreditivaTurnover/AnalisePreditivaTurnover.vue';
import Assinatura from './views/Assinatura/Assinatura.vue';
import RegistroPontoRedirect from './views/RegistroPontoRedirect.vue';

interface RouteMetadata {
  permission: {
    module: ModuloPermissao,
    action: ActionPermissao,
  },
}

interface TkRoute {
  name: string;
  label: string;
  component: VueClass;
  icon: string;
  link: string;
  showInMenu?: boolean;
  default?: boolean;
  meta?: RouteMetadata;
  hideFooter?: boolean;
  hideHeader?: boolean;
  hideMenu?: boolean;
  offline?: boolean;
}

const routes: TkRoute[] = [
  {
    name: 'login',
    label: 'Login',
    component: Login,
    showInMenu: false,
    icon: 'mdi-view-dashboard',
    link: '/login',
    offline: true,
  },
  {
    name: 'dashboard',
    label: 'Página Inicial',
    component: Dashboard,
    default: true,
    icon: 'mdi-view-dashboard',
    link: '/',
  },
  {
    name: 'demonstrativo',
    label: 'Demonstrativo',
    component: Demonstrativo,
    icon: 'insert_drive_file',
    link: '/demonstrativo',
    showInMenu: true,
    meta: {
      permission: { module: ModuloPermissao.MODULO_DEMONSTRATIVO, action: ActionPermissao.IDVISUALIZAR }
    }
  },
  {
    name: 'registroPonto',
    label: 'Registro Ponto Unidade',
    component: RegistroPontoRedirect,
    icon: 'add_circle',
    link: '/registroPonto',
    meta: {
      permission: { module: ModuloPermissao.MODULO_REGISTRO_PONTO_UNIDADE, action: ActionPermissao.IDVISUALIZAR }
    },
    offline: true,
  },
  {
    name: 'lancamentoFolha',
    label: 'Lançamento de Folha',
    component: LancamentoFolha,
    icon: 'mdi-file-chart',
    link: '/lancamentoFolha',
    meta: {
      permission: { module: ModuloPermissao.MODULO_LANCAMENTO_DE_FOLHA, action: ActionPermissao.IDVISUALIZAR }
    }
  },
  {
    name: 'aprovacaoOcorrencia',
    label: 'Ocorrências',
    component: AprovacaoOcorrencia,
    icon: 'done_all',
    link: '/aprovacaoOcorrencia',
    meta: {
      permission: { module: ModuloPermissao.MODULO_OCORRENCIAS, action: ActionPermissao.IDVISUALIZAR }
    }
  },
  {
    name: 'programacaoFerias',
    label: 'Programação de Férias',
    component: ProgramacaoFerias,
    icon: 'content_paste',
    link: '/programacaoFerias',
    meta: {
      permission: { module: ModuloPermissao.MODULO_PROGRAMACAO_DE_FERIAS, action: ActionPermissao.IDVISUALIZAR }
    }
  },
  {
    name: 'solicitacao',
    label: 'Solicitação',
    component: Solicitacao,
    icon: 'swap_vert',
    link: '/solicitacao',
    meta: {
      permission: { module: ModuloPermissao.MODULO_SOLICITACAO, action: ActionPermissao.IDVISUALIZAR }
    }
  },
  {
    name: 'documentos',
    label: 'Documentos',
    component: Documentos,
    icon: 'mdi-folder-open',
    link: '/documentos',
    meta: {
      permission: { module: ModuloPermissao.MODULO_DOCUMENTOS, action: ActionPermissao.IDVISUALIZAR }
    }
  },
  {
    name: 'admissao',
    label: 'Admissão',
    component: Admissao,
    icon: 'mdi-account-star',
    link: '/admissao',
    meta: {
      permission: { module: ModuloPermissao.MODULO_ADMISSAO, action: ActionPermissao.IDVISUALIZAR }
    }
  },
  {
    name: 'relatorio',
    label: 'Relatório',
    component: Relatorio,
    icon: 'mdi-file-chart',
    link: '/relatorio',
    meta: {
      permission: { module: ModuloPermissao.MODULO_RELATORIO, action: ActionPermissao.IDVISUALIZAR }
    }
  },
  {
    name: 'quadroGeralVinculo',
    label: 'Quadro Geral de Vínculos',
    component: QuadroGeralVinculo,
    icon: 'mdi-account-group',
    link: '/quadroGeralVinculo',
    meta: {
      permission: { module: ModuloPermissao.MODULO_QUADRO_GERAL_DE_VINCULOS, action: ActionPermissao.IDVISUALIZAR }
    }
  },
  {
    name: 'comunicadoAcidenteTrabalho',
    label: 'CAT - Comunicado Acidente Trabalho',
    component: ComunicadoAcidenteTrabalho,
    icon: 'mdi-alert-octagon',
    link: '/comunicadoAcidenteTrabalho',
    showInMenu: true,
    meta: {
      permission: { module: ModuloPermissao.MODULO_CAT_COMUNICADO_ACIDENTE_TRABALHO, action: ActionPermissao.IDVISUALIZAR }
    }
  },
  {
    name: 'controleEntregaEPI',
    label: 'Controle de Entrega de EPI',
    component: ControleEntregaEPI,
    icon: 'mdi-hospital-box',
    link: '/controleEntregaEPI',
    meta: {
      permission: { module: ModuloPermissao.MODULO_CONTROLE_DE_ENTREGA_DE_EPI, action: ActionPermissao.IDVISUALIZAR }
    }
  },
  {
    name: 'hierarquiaOrganizacao',
    label: 'Organograma da Organização',
    component: HierarquiaOrganizacao,
    icon: 'mdi-family-tree',
    link: '/organogramaOrganizacao',
    meta: {
      permission: { module: ModuloPermissao.MODULO_ORGANOGRAMA_DA_ORGANIZACAO, action: ActionPermissao.IDVISUALIZAR }
    }
  },
  {
    name: 'recrutamentoSelecao',
    label: 'Recrutamento e Seleção',
    component: RecrutamentoSelecao,
    icon: 'mdi-star-circle',
    link: '/recrutamentoSelecao',
    meta: {
      permission: { module: ModuloPermissao.MODULO_RECRUTAMENTO_E_SELECAO, action: ActionPermissao.IDVISUALIZAR }
    }
  },
  {
    name: 'biometriaFacial',
    label: 'Biometria Facial',
    component: BiometriaFacial,
    icon: 'mdi-face-recognition',
    link: '/biometriaFacial',
    meta: {
      permission: { module: ModuloPermissao.MODULO_BIOMETRIA_FACIAL, action: ActionPermissao.IDVISUALIZAR }
    }
  },
  {
    name: 'ocorrenciasPontoOffline',
    label: 'Ocorrências de Ponto Offline',
    component: OcorrenciasPontoOffline,
    icon: 'mdi-access-point-off',
    link: '/ocorrenciasPontoOffline',
    showInMenu: OfflineController.isMobile(),
    offline: true,
  },
  {
    name: 'indicadoresAcidentes',
    label: 'Indicadores Saude e Segurança do trabalho',
    component: IndicadoresSST,
    icon: 'mdi-hospital-box',
    link: '/indicadoresAcidentes',
    showInMenu: false,
  },
  {
    name: 'indicadoresEpis',
    label: 'Indicadores Saude e Segurança do trabalho',
    component: IndicadoresEpis,
    icon: 'mdi-hospital-box',
    link: '/indicadoresEpis',
    showInMenu: false,
  },
  {
    name: 'IndicadoresReunioes',
    label: 'Indicadores Saude e Segurança do trabalho',
    component: IndicadoresReunioes,
    icon: 'mdi-hospital-box',
    link: '/IndicadoresReunioes',
    showInMenu: false,
  },
  {
    name: 'IndicadoresAfastamentos',
    label: 'Indicadores Saude e Segurança do trabalho',
    component: IndicadoresAfastamentos,
    icon: 'mdi-hospital-box',
    link: '/IndicadoresAfastamentos',
    showInMenu: false,
  },
  {
    name: 'IndicadoresVariacaoSalarial',
    label: 'Indicadores De Variacão Salarial',
    component: IndicadoresVariacaoSalarial,
    icon: 'mdi-chart-line',
    link: '/IndicadoresVariacaoSalarial',
    showInMenu: false,
  },
  {
    name: 'controleAcesso',
    label: 'Controle de Acesso',
    component: ControleAcesso,
    icon: 'mdi-security',
    link: '/controleAcesso',
    showInMenu: false,
  },
  {
    name: 'mesaOperacoes',
    label: 'Mesa de Operações',
    component: MesaOperacoes,
    icon: 'mdi-monitor-dashboard',
    link: '/mesaOperacoes',
    showInMenu: true,
  },
  {
    name: 'analisePreditivaTurnover',
    label: 'Análise Preditiva de Turnover',
    component: AnalisePreditivaTurnover,
    icon: 'mdi-chart-bell-curve-cumulative',
    link: '/analisePreditivaTurnover',
    showInMenu: true,
  },
  {
    name: 'assinatura',
    label: 'Assinatura Digital',
    component: Assinatura,
    icon: 'mdi-draw',
    link: '/assinatura',
    showInMenu: true,
  },
];

export const routesLinkMap = routes.reduce((acc, route) => {
  acc[route.link] = route;
  return acc;
}, {} as Record<string, TkRoute>);

export const findRoute = (link: string): TkRoute => {
  return routesLinkMap[link] || null;
}

export default routes;